<script setup lang="ts">
import SvgIcon from "@/components/ui/SvgIcon/SvgIcon.vue";
import type { Icon } from "@/model/icon";

defineProps<{ icon?: Icon }>();
</script>

<template>
  <li class="list-empty">
    <SvgIcon v-if="icon" :name="icon" class="empty-icon" width="20" height="20" />
    <div v-if="$slots.default" class="empty-text">
      <slot />
    </div>
    <slot name="after" />
  </li>
</template>

<style lang="scss" scoped>
@use "@/styles/variables/colors";
@use "@/styles/mixins/typography";

.list-empty {
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 0 12px;

  .empty-icon {
    color: colors.$icon-subtle;
  }

  .empty-text {
    @include typography.small("semi-bold");

    color: colors.$text-subtle;
    text-align: center;
  }
}
</style>
